import { createSlice  } from '@reduxjs/toolkit';
import {
  createLineChartOptions, createMixedChartOptions, 
} from '../../utils/chart';
import _cloneDeep from 'lodash/cloneDeep';

const initialState = {
  registeredUsersChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  registeredAnimalsChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  animalsStatusChart: {
    requesting: false,
    error: null,
    success: false,
    filters: {},
    chartData: {
      options: {},
      series: []
    },
  },
  widgetsData: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  topFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },  
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    getRegisteredUsersChart: (state, action) => {		
      state.registeredUsersChart.requesting = true;
      state.registeredUsersChart.error = null;
      state.registeredUsersChart.success = false;
      state.registeredUsersChart.filters = action.payload;
    },
    getRegisteredUsersChartSuccess: (state, action) => {
      const { categories, series } = action.payload;
      state.registeredUsersChart.requesting = false;
      state.registeredUsersChart.success = true;
      state.registeredUsersChart.chartData.options = createMixedChartOptions(categories, series);
      state.registeredUsersChart.chartData.series = series;
    },
    getRegisteredUsersChartFail: (state, action) => {   
      state.registeredUsersChart.requesting = false;
      state.registeredUsersChart.error = action.payload;
      state.registeredUsersChart.success = false;
    },

    getRegisteredAnimalsChart: (state, action) => {		
      state.registeredAnimalsChart.requesting = true;
      state.registeredAnimalsChart.error = null;
      state.registeredAnimalsChart.success = false;
      state.registeredAnimalsChart.filters = action.payload;
    },
    getRegisteredAnimalsChartSuccess: (state, action) => {
      const { categories, series } = action.payload;
      state.registeredAnimalsChart.requesting = false;
      state.registeredAnimalsChart.success = true;
      state.registeredAnimalsChart.chartData.options = createLineChartOptions(categories, 'Registered Animals');
      state.registeredAnimalsChart.chartData.series = series;
    },
    getRegisteredAnimalsChartFail: (state, action) => {   
      state.registeredAnimalsChart.requesting = false;
      state.registeredAnimalsChart.error = action.payload;
      state.registeredAnimalsChart.success = false;
    },

    getAnimalsStatusChart: (state, action) => {		
      state.animalsStatusChart.requesting = true;
      state.animalsStatusChart.error = null;
      state.animalsStatusChart.success = false;
      state.animalsStatusChart.filters = action.payload;
    },
    getAnimalsStatusChartSuccess: (state, action) => {
      const { categories, series } = action.payload;
      state.animalsStatusChart.requesting = false;
      state.animalsStatusChart.success = true;
      state.animalsStatusChart.chartData.options = createLineChartOptions(categories, 'Animals Conditions');
      state.animalsStatusChart.chartData.series = series;
    },
    getAnimalsStatusChartFail: (state, action) => {   
      state.animalsStatusChart.requesting = false;
      state.animalsStatusChart.error = action.payload;
      state.animalsStatusChart.success = false;
    },  
    
    getWidgetData: (state, action) => {		      
      state.widgetsData.requesting = true;
      state.widgetsData.error = null;
      state.widgetsData.success = false;
      state.widgetsData.filters = action.payload;
    },
    getWidgetDataSuccess: (state, action) => {
      state.widgetsData.requesting = false;
      state.widgetsData.data = action.payload;
      state.widgetsData.success = true; 
    },
    getWidgetDataFail: (state, action) => {        
      state.widgetsData.requesting = false;
      state.widgetsData.error = action.payload;
    },

    getTopFarmers: (state, action) => {		      
      state.topFarmers.requesting = true;
      state.topFarmers.error = null;
      state.topFarmers.success = false;
      state.topFarmers.filters = action.payload;
    },
    getTopFarmersSuccess: (state, action) => {
      state.topFarmers.requesting = false;
      state.topFarmers.items = action.payload;
      state.topFarmers.success = true; 
    },
    getTopFarmersFail: (state, action) => {        
      state.topFarmers.requesting = false;
      state.topFarmers.error = action.payload;
    },
    
  },
})

export const { 
  getRegisteredUsersChart, getRegisteredUsersChartSuccess, getRegisteredUsersChartFail,
  getRegisteredAnimalsChart, getRegisteredAnimalsChartSuccess, getRegisteredAnimalsChartFail,
  getAnimalsStatusChart, getAnimalsStatusChartSuccess, getAnimalsStatusChartFail,
  getWidgetData, getWidgetDataSuccess, getWidgetDataFail,
  getTopFarmers, getTopFarmersSuccess, getTopFarmersFail
} = dashboardSlice.actions

export default dashboardSlice.reducer